import { ApiResponse } from 'app/app.types';

export function mockSuccess<T>(payload: T, message = 'OK'): ApiResponse<T> {
    return {
        id: `mock-${Date.now()}`,
        status: 'success',
        title: 'Mock',
        message,
        httpCode: 200,
        code: 'MOCK_OK',
        errors: null as T,
        payload,
    };
}

export function listPayload<T>(rows: T[]): { data: T[] } {
    return { data: rows };
}
